(function () {
  'use strict';

  const WORKER_URL = "https://yuna.chatelain-j.workers.dev";
  const AVATAR_URL = "https://cdn.shopify.com/s/files/1/1069/9630/2162/files/yuna_reflechi_4ea570be-d2c5-44be-9c7e-583d7658d8a8.jpg";
  const BOOT_MSG = "안녕 / Annyeong, moi c'est Yuna 🌿\n\nJe suis ta consultante K-beauty personnelle. Mon rôle : t'aider à comprendre ta peau, améliorer ta routine et choisir les soins vraiment adaptés — pas une routine générique, la tienne.\n\nQu'est-ce qui t'amène aujourd'hui ?\n\nOn me consulte souvent pour l'une de ces raisons :\n1. Ma peau me donne du fil à retordre\n2. J'aimerais améliorer ma routine actuelle\n3. J'ai une question sur la K-Beauty\n4. Un produit m'intrigue et j'aimerais ton avis";

  const SESSION_KEY = 'yuna_session_id';
  const HISTORY_KEY = 'yuna_history';
  const ENRICHED_CART_KEY = 'yuna_enriched_cart';

  // ── Session first-party, stable tant que le localStorage n'est pas purgé ──
  let SESSION_ID = localStorage.getItem(SESSION_KEY);
  if (!SESSION_ID) {
    SESSION_ID = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, SESSION_ID);
  }

  let history = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
  let loading = false;

  // ── PostHog (instance globale du thème, déjà chargée) ──
  const ph = {
    capture: function (event, props) {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props);
      }
    }
  };

  var yunaQuizStarted = false;
  var yunaCartShown = false;
  var yunaQuizStartTime = null;
  var yunaUserMessageCount = 0;
  var yunaCartAbandoned = false;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && yunaQuizStarted && !yunaCartAbandoned) {
      ph.capture('yuna_quiz_abandoned', {
        last_step: yunaUserMessageCount,
        time_spent_seconds: yunaQuizStartTime ? Math.round((Date.now() - yunaQuizStartTime) / 1000) : 0,
        cart_was_shown: yunaCartShown,
        session_id: SESSION_ID
      });
    }
  });

  const root = document.getElementById('yuna-chat-root');
  if (!root) return; // section pas présente sur cette page

  const msgContainer = root.querySelector('[data-yw-messages]');
  const textarea = root.querySelector('[data-yw-textarea]');
  const sendBtn = root.querySelector('[data-yw-send]');
  const resetBtn = root.querySelector('[data-yw-reset]');
  const resetModal = root.querySelector('[data-yw-reset-modal]');

  function scrollBottom() { msgContainer.scrollTop = msgContainer.scrollHeight; }

  function scrollToNewAssistantMessage(row) {
    const containerHeight = msgContainer.clientHeight;
    const rowHeight = row.offsetHeight;
    if (rowHeight > containerHeight - 40) {
      row.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else {
      scrollBottom();
    }
  }

  function makeAvatar() {
    const wrap = document.createElement('div');
    wrap.className = 'yw-msg-avatar';
    const img = document.createElement('img');
    img.src = AVATAR_URL; img.alt = 'Yuna';
    wrap.appendChild(img);
    return wrap;
  }

  function addMessage(role, text) {
    const row = document.createElement('div');
    row.className = 'yw-row ' + (role === 'assistant' ? 'yuna' : 'user');
    if (role === 'assistant') row.appendChild(makeAvatar());
    const bubble = document.createElement('div');
    bubble.className = 'yw-bubble';
    bubble.textContent = text;
    row.appendChild(bubble);
    msgContainer.appendChild(row);
    if (role === 'assistant') {
      scrollToNewAssistantMessage(row);
    } else {
      scrollBottom();
    }
    return row;
  }

  function addQuickReplies(replies) {
    const row = document.createElement('div');
    row.className = 'yw-row yuna';
    row.appendChild(makeAvatar());
    const wrapper = document.createElement('div');
    const container = document.createElement('div');
    container.className = 'yw-quick-replies';
    replies.forEach(function (reply) {
      const btn = document.createElement('button');
      btn.className = 'yw-quick-reply';
      btn.type = 'button';
      btn.textContent = reply;
      btn.onclick = function () {
        root.querySelectorAll('.yw-quick-replies').forEach(el => {
          const r = el.closest('.yw-row');
          if (r) r.remove();
        });
        textarea.value = reply;
        autoResize();
        setTimeout(function () { send(); }, 250);
      };
      container.appendChild(btn);
    });
    wrapper.appendChild(container);
    row.appendChild(wrapper);
    msgContainer.appendChild(row);
  }

  function showTyping() {
    const row = document.createElement('div');
    row.className = 'yw-typing';
    row.setAttribute('data-yw-typing-indicator', '');
    row.appendChild(makeAvatar());
    const bub = document.createElement('div');
    bub.className = 'yw-typing-bubble';
    bub.innerHTML = '<span class="yw-td"></span><span class="yw-td"></span><span class="yw-td"></span>';
    row.appendChild(bub);
    msgContainer.appendChild(row);
    scrollBottom();
  }

  function hideTyping() {
    const el = root.querySelector('[data-yw-typing-indicator]');
    if (el) el.remove();
  }

  function setLoading(val) {
    loading = val;
    textarea.disabled = val;
    sendBtn.disabled = val || !textarea.value.trim();
  }

  function autoResize() {
    textarea.style.height = '22px';
    textarea.style.height = Math.min(textarea.scrollHeight, 96) + 'px';
  }

  function parseReply(raw) {
    const sep = '---CART---';
    const normalized = raw.replace(/\s*---CART---\s*/g, sep);
    const parts = normalized.split(sep);
    if (parts.length === 3) {
      try { return { text: parts[0].trim(), cart: JSON.parse(parts[1].trim()) }; }
      catch (e) { console.error('Cart JSON parse error:', e); }
    }
    return { text: raw, cart: null };
  }

  // ── Construit le bloc cart. Navigation produit directe (même origine). ──
  function buildCartBlock(cart) {
    const block = document.createElement('div');
    block.className = 'yw-cart-block';

    // Défense contre un panier mal hydraté côté serveur (prix ou
    // variant_id manquant) : on ne rend jamais "undefined€", et on
    // n'envoie jamais un produit invalide à Shopify. Un produit incomplet
    // est écarté du panier affiché plutôt que cassé silencieusement.
    const validProducts = cart.products.filter(function (p) {
      return p && typeof p.price === 'number' && !isNaN(p.price) && p.variant_id;
    });
    const invalidCount = cart.products.length - validProducts.length;

    const title = document.createElement('div');
    title.className = 'yw-cart-title';
    title.textContent = cart.is_starter ? '✨ Le kit parfait pour commencer' : '✨ Ta routine sur-mesure';
    block.appendChild(title);

    if (invalidCount > 0) {
      const warn = document.createElement('div');
      warn.className = 'yw-cart-error';
      warn.textContent = invalidCount === 1
        ? "Un produit n'a pas pu être chargé correctement et n'apparaît pas ci-dessous. Dis-le à Yuna si besoin, elle pourra réessayer."
        : "Certains produits n'ont pas pu être chargés correctement et n'apparaissent pas ci-dessous. Dis-le à Yuna si besoin, elle pourra réessayer.";
      block.appendChild(warn);
    }

    if (validProducts.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'yw-cart-error';
      empty.textContent = "Je n'ai pas réussi à charger cette routine correctement. Dis à Yuna de réessayer.";
      block.appendChild(empty);
      return block;
    }

    let total = 0;
    validProducts.forEach(function (p, idx) {
      const item = document.createElement('div');
      item.className = 'yw-cart-item';

      const header = document.createElement('div');
      header.className = 'yw-cart-item-header';

      const badge = document.createElement('span');
      badge.className = 'yw-cart-item-badge';
      badge.textContent = idx + 1;
      header.appendChild(badge);

      const nameWrap = document.createElement('span');
      nameWrap.className = 'yw-cart-item-name';

      const nameText = document.createElement('strong');
      nameText.className = 'yw-cart-item-name-text';
      nameText.textContent = p.name;
      nameWrap.appendChild(nameText);

      const priceText = document.createElement('span');
      priceText.className = 'yw-cart-item-price';
      priceText.textContent = ' — ' + p.price + '€';
      nameWrap.appendChild(priceText);

      header.appendChild(nameWrap);

      if (p.handle) {
        const linkBtn = document.createElement('a');
        linkBtn.className = 'yw-product-link';
        linkBtn.textContent = 'Voir →';
        linkBtn.href = '/products/' + p.handle;
        linkBtn.setAttribute('aria-label', 'Voir la page produit de ' + p.name);
        linkBtn.addEventListener('click', function () {
          ph.capture('yuna_product_link_clicked', {
            product_name: p.name,
            handle: p.handle,
            session_id: SESSION_ID
          });
        });
        header.appendChild(linkBtn);
      }
      item.appendChild(header);

      if (p.reason) {
        const reason = document.createElement('div');
        reason.className = 'yw-cart-item-reason';
        reason.textContent = p.reason;
        item.appendChild(reason);
      }

      block.appendChild(item);
      total += parseFloat(p.price);
    });

    const totalReduit = (total * 0.9).toFixed(2);

    if (cart.summary) {
      const summary = document.createElement('div');
      summary.className = 'yw-cart-summary';
      summary.textContent = cart.summary;
      block.appendChild(summary);
    }

    const promoBar = document.createElement('div');
    promoBar.style.cssText = 'background:#eaf3de;border-radius:8px;padding:8px 12px;font-size:12px;color:#3b6d11;margin-top:2px;';
    promoBar.innerHTML = '🎁 Réduction exclusive Yuna <strong>-10%</strong> appliquée automatiquement';
    block.appendChild(promoBar);

    const errorBox = document.createElement('div');
    errorBox.className = 'yw-cart-error';
    errorBox.style.display = 'none';
    block.appendChild(errorBox);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yw-cart-btn';
    btn.innerHTML = 'Ajouter au panier — <s style="opacity:0.6">' + total.toFixed(2) + '€</s> <strong>' + totalReduit + '€</strong>';
    btn.addEventListener('click', function () {
      handleAddToCart(validProducts, btn, cart, total, totalReduit, errorBox);
    });
    block.appendChild(btn);

    if (!yunaCartShown) {
      yunaCartShown = true;
      ph.capture('yuna_selection_shown', {
        products: cart.products.map(function (p) { return p.variant_id; }),
        products_count: cart.products.length,
        total_price: parseFloat(total.toFixed(2)),
        total_price_discounted: parseFloat(totalReduit),
        is_starter: cart.is_starter || false,
        messages_exchanged: yunaUserMessageCount,
        session_id: SESSION_ID
      });
    }

    return block;
  }

  // ── Ajout panier : direct, awaité, avec gestion d'échec réelle ──
  async function handleAddToCart(products, btn, cart, total, totalReduit, errorBox) {
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';
    errorBox.style.display = 'none';
    yunaCartAbandoned = true;

    ph.capture('yuna_cta_clicked', {
      products: products.map(function (p) { return p.variant_id; }),
      products_count: products.length,
      total_price: parseFloat(total.toFixed(2)),
      total_price_discounted: parseFloat(totalReduit),
      is_starter: cart.is_starter || false,
      messages_exchanged: yunaUserMessageCount,
      time_to_cta_seconds: yunaQuizStartTime ? Math.round((Date.now() - yunaQuizStartTime) / 1000) : null,
      session_id: SESSION_ID
    });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: products.map(function (p) { return { id: parseInt(p.variant_id, 10), quantity: 1 }; }),
          attributes: { yuna_session_id: SESSION_ID }
        })
      });

      if (!res.ok) {
        const body = await res.json().catch(function () { return {}; });
        throw new Error(body.description || ('HTTP ' + res.status));
      }

      btn.textContent = '✓ Redirection vers le panier…';
      btn.style.background = '#8FA68C';
      window.location.href = '/checkout?discount=YUNA10';

    } catch (e) {
      console.error('Yuna cart error:', e);
      btn.disabled = false;
      btn.classList.add('yw-cart-btn--error');
      btn.innerHTML = 'Réessayer l\u2019ajout au panier';
      errorBox.style.display = 'block';
      errorBox.textContent = 'Un des produits n\u2019a pas pu être ajouté (' + e.message + '). Tu peux réessayer, ou l\u2019ajouter directement depuis sa page produit.';
      ph.capture('yuna_cart_add_failed', { error: e.message, session_id: SESSION_ID });
    }
  }

  // ── Démarrage : historique local, ou message d'accueil ──
  function bootNormal() {
    if (history.length > 0) {
      history.forEach(function (m) {
        if (m.role === 'user') {
          addMessage('user', m.content);
          yunaUserMessageCount++;
          return;
        }
        // Le texte peut encore contenir un ---CART--- résiduel dans le
        // chemin freeform historique ; on l'extrait juste pour l'affichage,
        // on ne construit plus le cart depuis ce marqueur (voir plus bas).
        const { text } = parseReply(m.content);
        addMessage('assistant', text);
      });

      // La routine est un état unique et mutable, pas un historique de
      // paniers par message : on affiche l'état COURANT une seule fois,
      // à la fin, plutôt que de tenter de retrouver quel message portait
      // quel panier.
      const saved = localStorage.getItem(ENRICHED_CART_KEY);
      if (saved) {
        try {
          const cart = JSON.parse(saved);
          if (cart && Array.isArray(cart.products) && cart.products.length > 0) {
            yunaCartShown = true;
            const row = document.createElement('div');
            row.className = 'yw-row yuna';
            row.appendChild(makeAvatar());
            row.appendChild(buildCartBlock(cart));
            msgContainer.appendChild(row);
          }
        } catch (e) {
          console.error('Enriched cart parse error on replay:', e);
        }
      }

      if (yunaUserMessageCount > 0) {
        yunaQuizStarted = true;
        yunaQuizStartTime = Date.now();
      }

      scrollBottom();
      return;
    }

    history.push({ role: 'assistant', content: BOOT_MSG });
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    addMessage('assistant', BOOT_MSG);
    addQuickReplies([
      "Ma peau me donne du fil à retordre",
      "J'aimerais améliorer ma routine",
      "J'ai une question sur la K-Beauty",
      "Un produit m'intrigue"
    ]);
  }

  bootNormal();

  // ── Envoi ──
  async function send() {
    const text = textarea.value.trim();
    if (!text || loading) return;

    if (!yunaQuizStarted) {
      yunaQuizStarted = true;
      yunaQuizStartTime = Date.now();
      ph.capture('yuna_quiz_started', { session_id: SESSION_ID });
    }
    yunaUserMessageCount++;
    ph.capture('yuna_quiz_step', { step_number: yunaUserMessageCount, session_id: SESSION_ID });

    history.push({ role: 'user', content: text });
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    addMessage('user', text);
    textarea.value = '';
    autoResize();
    setLoading(true);
    showTyping();

    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history, session_id: SESSION_ID }),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const data = await res.json();
      const raw = data?.reply || data?.message || data?.text || '';
      const enrichedCart = data?.cart || null;
      const quickReplies = Array.isArray(data?.quickReplies) ? data.quickReplies : [];

      const { text: replyText, cart: rawCart } = parseReply(raw);
      const cart = enrichedCart || rawCart;
      const reply = replyText || "Désolée, une erreur s'est produite 🌿";

      if (enrichedCart) {
        localStorage.setItem(ENRICHED_CART_KEY, JSON.stringify(enrichedCart));
      } else {
        // Le panier reflète l'état courant de la routine ; s'il est vide
        // maintenant (ex: la cliente a tout retiré), on efface la trace
        // précédente au lieu de laisser un panier périmé réapparaître au F5.
        localStorage.removeItem(ENRICHED_CART_KEY);
      }

      history.push({ role: 'assistant', content: raw });
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
      hideTyping();
      addMessage('assistant', reply);

      if (quickReplies.length) {
        addQuickReplies(quickReplies);
      }

      if (cart) {
        // Pas de scroll ici : on laisse la vue là où scrollToNewAssistantMessage
        // l'a positionnée (début du message), pour que la cliente lise les
        // justifications avant de voir la routine et le CTA plus bas.
        const row = document.createElement('div');
        row.className = 'yw-row yuna';
        row.appendChild(makeAvatar());
        row.appendChild(buildCartBlock(cart));
        msgContainer.appendChild(row);
      }

      // Signale au reste du site (bubble, etc.) qu'une session existe désormais
      window.dispatchEvent(new CustomEvent('yuna:sessionReady', { detail: { session_id: SESSION_ID } }));

    } catch (e) {
      console.error(e);
      hideTyping();
      ph.capture('yuna_api_error', { step_number: yunaUserMessageCount, error: e.message, session_id: SESSION_ID });
      const err = "Une erreur de connexion s'est produite. Réessaie dans un instant 🌿";
      history.push({ role: 'assistant', content: err });
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
      addMessage('assistant', err);
    } finally {
      setLoading(false);
      textarea.focus();
    }
  }

  textarea.addEventListener('input', function () {
    autoResize();
    sendBtn.disabled = loading || !textarea.value.trim();
  });
  textarea.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  sendBtn.addEventListener('click', send);

  // ── Reset ──
  resetBtn.addEventListener('click', function () {
    resetModal.classList.remove('hidden');
  });

  resetModal.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-yw-reset-cancel') || e.target === resetModal) {
      resetModal.classList.add('hidden');
    }
    if (e.target.hasAttribute('data-yw-reset-confirm')) {
      localStorage.removeItem(HISTORY_KEY);
      localStorage.removeItem(ENRICHED_CART_KEY);
      localStorage.removeItem(SESSION_KEY);
      location.reload();
    }
  });

})();